// All possible units

enum LengthUnit {
  Millimeter = 'mm',
  Centimeter = 'cm',
  Meter = 'm',
  Inch = 'in',
  Foot = 'ft',
  Yard = 'yd',
}

enum WeightUnit {
  Milligram = 'mg',
  Gram = 'g',
  Kilogram = 'kg',
  MetricTon = 't',
  Ounce = 'oz',
  Pound = 'lb',
  Stone = 'st',
  ShortTon = 'sht',
}

interface MeasurementType {
  length: LengthUnit;
  weight: WeightUnit;
}

const metricSystem = {
  length: LengthUnit.Centimeter,
  weight: WeightUnit.Kilogram,
};

const imperialSystem = {
  length: LengthUnit.Inch,
  weight: WeightUnit.Pound,
};

export const commonUnitsPerLocale: Record<any, MeasurementType> = Object.freeze({
  'en-US': imperialSystem,
  'en-GB': metricSystem,
  de: metricSystem,
  fr: metricSystem,
  ja: metricSystem,
  pt: metricSystem,
  'zh-CN': metricSystem,
  nl: metricSystem,
  es: metricSystem,
});

export const measurementUnits = Object.freeze({
  length: LengthUnit,
  weight: WeightUnit,
});
